/**
 * Created by idea on 03/07/2017.
 */
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { TabsComponent } from '../tabs/tabs.component';
import { ProcessListener, process } from '../../components/process/process.listener';

declare var $: any;

@Component({
  selector: 'admin',
  templateUrl: 'admin.template.html',
  styleUrls: ['style.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ProcessListener],
})
// tslint:disable-next-line:class-name
export class adminComponent implements OnInit {
  public typeNav = '';
  public menuHide = false;
  public is_select_tab: any = false;
  public is_select_left_menu: any = true;
  public hide_tab: any = false;

  public force_new_tab: any = false;

  @ViewChild('ticketTemplate') ticketTemplate;
  @ViewChild(TabsComponent) tabsComponent;
  public downloadCount = 0;

  startDownload() {
    this.downloadCount++;
  }

  finishDownload() {
    if (this.downloadCount > 0) {
      this.downloadCount--;
    }
  }

  constructor() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('page-login-v2');
    body.classList.remove('page-register-v2');
    body.classList.remove('layout-full');
    body.classList.remove('page-dark');
    body.classList.add('site-menubar-unfold');
    process.onAddDownloadProcess.subscribe(data => {
      this.startDownload();
    });
    process.onRemoveDownloadProcess.subscribe(data => {
      this.finishDownload();
    });
  }
  ngOnInit() {}

  handleNavUpdated(type) {
    this.typeNav = type;
  }

  toggleMenu() {
    if (!this.menuHide) {
      $('.menu-block').addClass('menu_hide');
      $('#evs_page').addClass('has_menu');
      $('.menu-block i.fa-bars').addClass('has_menu');
      this.menuHide = true;
    } else {
      $('.menu-block').removeClass('menu_hide');
      $('#evs_page').removeClass('has_menu');
      $('.menu-block i.fa-bars').removeClass('has_menu');
      this.menuHide = false;
    }
  }

  createNewTab() {
    this.force_new_tab = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/layouts/admin.component.ts